<template>
    <div class="md-social-post standard" v-if="posts && posts.length">
        <module-box
            class="container"
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="mg-title" v-if="title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div
                class="social-icon-list"
                v-if="socialTypes && socialTypes.length"
            >
                <SocialMediaLink
                    class="social-item"
                    v-for="item in socialTypes"
                    :key="item.link"
                    :item="item"
                />
            </div>
            <div class="social-media-post-conatiner" ref="waterfall">
                <div
                    class="column"
                    v-for="(columnData, idx1) in columns"
                    :key="idx1"
                >
                    <Card
                        ref="card"
                        class="social-meida-post"
                        v-for="value in columnData"
                        :key="value.channelId"
                        @update:height="
                            (value.height = $event) && calcColumns()
                        "
                        v-bind="value"
                    />
                </div>
            </div>
            <p class="view-more" v-show="hasMore">
                <span @click="loadMore">{{ moreText }}</span>
            </p>
        </module-box>
    </div>
</template>
<script>
import Card from './card.vue';
import SocialMediaLink from './socialMediaLink.vue';
import common from '../index';
import columns from '../columns';
const LinkedIn_TYPE = 3;
const GoogleBusiness_TYPE = 7;
const Youtube_TYPE = 4;
export default {
    name: 'MdSocialPostStandard',
    components: { Card, SocialMediaLink },
    mixins: [common, columns],
    computed: {
        socialTypes({ socialLinks }) {
            let retMap = new Map(),
                len = socialLinks.length;
            for (let i = 0; i < len; i++) {
                let item = socialLinks[i];
                let { socialType, link } = item;
                if (socialType == LinkedIn_TYPE && !link) {
                    continue;
                }
                if ([GoogleBusiness_TYPE, Youtube_TYPE].includes(socialType)) {
                    //  hide googleBusiness and youtube
                    continue;
                }
                if (retMap.has(socialType)) {
                    let socialVal = retMap.get(socialType);
                    socialVal.hasMore = true;
                    socialVal.list.push(item);
                } else {
                    retMap.set(socialType, {
                        ...item,
                        list: [item],
                        hasMore: false,
                        openMore: false
                    });
                }
            }
            return Array.from(retMap.values());
        }
    }
};
</script>
<style lang="scss">
.md-social-post.standard {
    > .container {
        overflow: visible;
    }
    .social-meida-post {
        margin-bottom: 20px;
        width: 100%;
    }
    @media (max-width: 600px) {
        .social-meida-post {
            margin-bottom: 10px;
        }
    }
    .social-media-post-conatiner {
        display: flex;
        > .column {
            flex: 1;
            margin-right: 20px;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .view-more {
        font-family: var(--font-normal);
        font-size: 14px;
        text-align: right;
        letter-spacing: 0;
        position: relative;
        cursor: pointer;
        color: var(--color-theme, #03c9ff);
    }
    .social-icon-list {
        display: flex;
        flex-wrap: wrap;
        .social-item {
            margin-right: 5px;
            margin-bottom: 5px;
        }
    }
}
</style>
